import React, { Component } from 'react';
import { downTabClose } from '../../helpers/Common';
import Getinbox from './Getinbox';
import Getarchive from './Getarchive'
import Compose from './Compose';
import Sent from './Sent';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getInbox } from '../../actions/inboxAction';
const $ = window.$;
class PersonalMessages extends Component {
	constructor(props) {
		super(props);
		this.state = {
			mailType: 'inbox',
			new_inbox: 0
		}


		// this.getComponent = this.getComponent.bind(this);
	}
	getTabs() {
		let self = this;
		$('#ChildVerticalTab_1').easyResponsiveTabs({
			type: 'vertical',
			width: 'auto',
			fit: true,
			tabidentify: 'ver_1',
		});

		$('.resp-accordion').click(function () {

			if ($(this).next().hasClass('inbox')) {
				self.getComponent('inbox');

			}

			if ($(this).next().hasClass('compose')) {
				self.getComponent('compose');
			}

			if ($(this).next().hasClass('compose')) {
				self.getComponent('compose');
			}
			if ($(this).next().hasClass('csent')) {
				self.getComponent('sent');
			}

			if ($(this).next().hasClass('archieve')) {
				self.getComponent('archieve');
			}

		});


		downTabClose();
	}
	getComponent(type) {


		this.setState({
			mailType: type
		})

		this.props.getInbox();
	}
	componentWillMount() {
		this.props.getInbox();

	}
	componentDidMount() {

		setTimeout(() => {
			this.getTabs();


			$("#inbox_click").click();
		}, 2000);
	}

	componentWillReceiveProps(nextProps) {
		if ($(window).width() < 768) {
			$(".verticaltab-content.inbox").prev().find('span.txt-red-msg').html('(' + nextProps.message + ' New )');
			// console.log('in');
		}
	}



	render() {
		let message_count = "";

		if (this.props.message !== undefined) {
			message_count = '(' + this.props.message + ' New )';
		}

		return (

			<section id="contentsection" className="contentarea">
				<div className="inner-title-bg journey-tit-bg">
					<h1><span><img src={process.env.PUBLIC_URL + "/images/message_title_img.jpg"} alt="" border="0" align="absmiddle" /></span>Messages<br /><span className="subtitle">Inbox, Compose, Send</span></h1>
				</div>
				<div className="myperformance">
					<section id="semana-scroll-inner" className="scroll">
						<section className="viewport">
							<section className="overview">
								<div className="inner-content">
									<div className="resp-tabs-container hor_1 tapmargntop message-tab" id="responsivediv_show">
										<div id="ChildVerticalTab_1">
											<ul className="resp-tabs-list ver_1">
												<a href="javascript:void(0);" id="inbox_click" onClick={() => this.getComponent('inbox')}><li >Inbox <span className="txt-red-msg">
													{message_count}


												</span></li></a>
												<a href="javascript:void(0);" onClick={() => this.getComponent('compose')}><li >Compose Mail</li></a>
												<a href="javascript:void(0);" onClick={() => this.getComponent('sent')}><li >Sent Mail</li></a>
												<a href="javascript:void(0);" onClick={() => this.getComponent('archieve')}><li >Archive Mails </li> </a>
											</ul>
											<div className="resp-tabs-container ver_1">
												<div className="verticaltab-content inbox">

													{(this.state.mailType === "inbox") ? <Getinbox /> : ""}
												</div>
												<div className="verticaltab-content compose">
													{(this.state.mailType === "compose") ? <Compose /> : ""}

												</div>
												<div className="verticaltab-content csent">
													{(this.state.mailType === "sent") ? <Sent /> : ""}

												</div>
												<div className="verticaltab-content archieve">
													{(this.state.mailType === "archieve") ? <Getarchive /> : ""}

												</div>
											</div>
										</div>
									</div>
								</div>
							</section>
						</section>
					</section>
				</div>
			</section>

		);
	}
}


function mapStateToProps(state, ownProps) {


	return {
		message: state.inbox.unread
	};
}

function mapDispatchToProps(dispatch) {

	return bindActionCreators({ getInbox }, dispatch);

}

export default connect(mapStateToProps, mapDispatchToProps)(PersonalMessages);



// WEBPACK FOOTER //
// ./src/personal_interactions/messages/PersonalMessages.js